export default {
    reduceCreditLimitOptions: {
        dataTrackId: 'reduce-credit-limit-options',
        dataTrackLinkname: 'senk kredittgrense alternativer',
    },
};
